import type { ProcessingState } from "@redux/state/shared-types";
import { rejectExternalProviderBatchRequest, resetRejectExternalProviderBatchRequest } from "./reject-external-provider-batch-request";
import { createReducer } from "@reduxjs/toolkit";

const initialState: ProcessingState = { processing: "idle" };

export const rejectExternalProviderBatchRequestReducer = createReducer<ProcessingState>(initialState, builder => {
  builder
    .addCase(rejectExternalProviderBatchRequest.fulfilled, state => {
      return {
        ...state,
        processing: "success",
      };
    })
    .addCase(rejectExternalProviderBatchRequest.pending, state => {
      return {
        ...state,
        processing: "pending",
      };
    })
    .addCase(rejectExternalProviderBatchRequest.rejected, state => {
      return {
        ...state,
        processing: "failed",
      };
    });
  builder.addCase(resetRejectExternalProviderBatchRequest, () => {
    return initialState;
  });
});
